module.exports = __webpack_public_path__ + "d544c50cc72ef02dc7e47121e2e281d2.svg";